import { render, staticRenderFns } from "./BPDivider.vue?vue&type=template&id=f40aa02a&"
import script from "./BPDivider.vue?vue&type=script&lang=js&"
export * from "./BPDivider.vue?vue&type=script&lang=js&"
import style0 from "./BPDivider.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BPDivider.vue"
export default component.exports